import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { Application } from '@frontend/functionality/types';
import React from 'react';

import useApplicationSelect from './application-select.controller';

const ID = 'application-select';
export interface ApplicationSelectProps extends Omit<SelectInputV2Props<Application>, 'options'> {
    subset?: string[];
}

export const ApplicationSelect = (props: ApplicationSelectProps) => {
    const viewProps = useApplicationSelect(props);
    return (
        <SelectInputV2<Application>
            {...props}
            id={ID + props.id}
            label={props.label || 'Application'}
            options={props.subset ? props.subset.map((s) => ({ value: s, label: s })) : viewProps.options}
        />
    );
};
